module.exports = __webpack_public_path__ + "img/tu03.522374af.jpg";